export const SigilMark = ({ className = "w-10 h-10", spin = false }) => (
  <svg
    viewBox="0 0 100 100"
    className={`${className} fill-none stroke-current ${spin ? "sigil-rotate" : ""}`}
    strokeWidth="1.5"
    aria-hidden="true"
  >
    <circle cx="50" cy="50" r="45" />
    <polygon points="50,10 85,75 15,75" />
    <polygon points="50,90 85,25 15,25" />
    <circle cx="50" cy="50" r="15" />
    <circle cx="50" cy="50" r="4" className="fill-current" stroke="none" />
  </svg>
);
